function isInpost(code) {
    return code.toLowerCase() === 'inpost';
}
function isKurierInpost(code) {
    return code.toLowerCase() === 'kurier_inpost';
}
function isOrlen(code) {
    return code.toLowerCase() === 'orlen';
}
function isFedex(code) {
    return code.toLowerCase() === 'fedex';
}
function isAmbro(code) {
    return code.toLowerCase() === 'ambro';
}
function isGls(code) {
    return code.toLowerCase() === 'gls';
}

export const CourierButton = {
    name: 'CourierButton',
    props: {
        code: String,
        size: String,
        isFull: Boolean,
        isOff: Boolean,
        isDomestic: Boolean,

        isAvailable: {
            type: Number,
            default: true
        }
    },
    computed: {
        classes() {
            return ['courier-button',
                'courier-button--' + this.size,
                'courier-button--' + this.code.toLowerCase(),
                this.isFull && 'courier-button--full',
                this.isOff && 'courier-button--inactive',
                !this.isAvailable && 'courier-button--not-available'
            ];
        },
        name() {
            if (this.size === 'small') {
                if (isKurierInpost(this.code)) {
                    this.code = 'KURIER INPOST';
                    return this.code.toUpperCase();
                }
                else if (isOrlen(this.code)) {
                    this.code = 'ORLEN';
                    return this.code.toUpperCase();
                }
                else {
                    return this.code.toUpperCase();
                }
            }

            if (isInpost(this.code) || (isKurierInpost(this.code))) {
                return 'InPost'
            }

            if (isOrlen(this.code)) {
                return 'ORLEN'
            }

            if (isFedex(this.code)) {
                return 'FedEx'
            }

            return this.code.toUpperCase();
        },
        subname() {
            if (this.size === 'small') {
                return;
            }
            if (isInpost(this.code)) {
                return 'Paczkomaty';
            }
            if (isKurierInpost(this.code)) {
                return 'Kurier';
            }
            if (isOrlen(this.code)) {
                return 'Paczka';
            }
            if (isAmbro(this.code)) {
                return 'Express';
            }
            if (isGls(this.code) && this.isDomestic) {
                this.classes.push('courier-button--gls-domestic');
                return 'ParcelShop';
            }
        }
    },
    template: `
        <span :class="classes">
            <span class="courier-button__name">{{name}}</span>
            <span class="courier-button__subname" v-if="subname">{{subname}}</span>
        </span>
    `
}
